import { Text } from "@repo/components/src/ui/text";

export default function MissingState() {
  return (
    <Text size="sm" action="muted">
      Pide a un administrador de la marca completar los datos de facturación.
    </Text>
  );
}
